import React from 'react';
import PropTypes from 'prop-types';
import '../../styles/CustomModal.css';

export function CustomModal({ customClass, children, close }) {
  return (
    <div
      className="modal-backdrop"
      onClick={() => {
        // close modal when outside of modal is clicked
        close();
      }}
    >
      <div
        className={customClass}
        onClick={(e) => {
          // do not close modal if anything inside modal content is clicked
          e.stopPropagation();
        }}
      >
        {children}
      </div>
    </div>
  );
}

CustomModal.propTypes = {
  children: PropTypes.any,
  customClass: PropTypes.string,
  close: PropTypes.func
};

export default CustomModal;
